let baseUrl = '';
let urlLocalFile = '';
let urlRemoteFile = '';
let urlApp = '';
let PUSHER_APP_KEY = '';
let PUSHER_APP_CLUSTER = '';

/*if (process.env.NODE_ENV === 'production') {
  baseUrl = 'https://dx360-api.frb.io';
  urlLocalFile = 'https://dx360-api.frb.io/storage';
  urlRemoteFile = 'https://dx360bucket.s3.af-south-1.amazonaws.com';
  urlApp = 'https://dx360-api.frb.io';

  PUSHER_APP_KEY = '2762f4d958726b891e5e';
  PUSHER_APP_CLUSTER = 'eu';
} else {
  baseUrl = 'http://127.0.0.1:8000';
  urlLocalFile = 'http://127.0.0.1:8000/storage';
  urlRemoteFile = 'http://127.0.0.1:8000/storage';
  urlApp = 'http://127.0.0.1:8000';

  PUSHER_APP_KEY = '2762f4d958726b891e5e';
  PUSHER_APP_CLUSTER = 'eu';
}*/

if (process.env.NODE_ENV === 'production') {
  baseUrl = 'https://api.erp-nett-champenois.com';
  urlLocalFile = 'https://api.erp-nett-champenois.com/storage';
  urlRemoteFile = 'https://dx360bucket.s3.af-south-1.amazonaws.com';
  urlApp = 'https://api.erp-nett-champenois.com';

  PUSHER_APP_KEY = '2762f4d958726b891e5e';
  PUSHER_APP_CLUSTER = 'eu';
} else {
  baseUrl = 'http://127.0.0.1:8000';
  urlLocalFile = 'http://127.0.0.1:8000/storage';
  urlRemoteFile = 'http://127.0.0.1:8000/storage';
  urlApp = 'http://127.0.0.1:8000';

  PUSHER_APP_KEY = '2762f4d958726b891e5e';
  PUSHER_APP_CLUSTER = 'eu';
}

const Config = {
  API_URL: baseUrl,
  URL_LOCAL_FILE: urlLocalFile,
  URL_REMOTE_FILE: urlRemoteFile,
  URL_APP: urlApp,
  PUSHER_APP_KEY: PUSHER_APP_KEY,
  PUSHER_APP_CLUSTER: PUSHER_APP_CLUSTER,
};

export default Config;
